import { render, staticRenderFns } from "./DemoAssessment.vue?vue&type=template&id=0b087622"
import script from "./DemoAssessment.vue?vue&type=script&lang=ts"
export * from "./DemoAssessment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports